/** Colunas do order by da pesquisa dos arquivos */
export enum ArquivoSearchOrderBy {
    ID = 1,
    CreatedAt = 2,
    Nome = 3,
    Extensao = 4,
    Referencia = 5,
    NomeTipoArquivo = 6,
    NomeUsuarioCreated = 7
};
